export function warnUnknownFields(converterName, value, knownFields) {
    const known = new Set(knownFields);
    const unknownFields = Object.keys(value).filter((field) => !known.has(field));
    if (unknownFields.length === 0)
        return;
    console.warn("Firestore converter received unrecognized fields", {
        converterName,
        unknownFields,
    });
}
